import { Injectable } from '@angular/core';

import { Observable, debounceTime, fromEvent, map } from 'rxjs';

@Injectable()
export class WindowResizeService {
  private resizeObservable$: Observable<Event> | undefined;

  private readonly MOBILE_WIDTH_SIZE = 768;

  get isMobileWidthSize(): boolean {
    return window.innerWidth <= this.MOBILE_WIDTH_SIZE;
  }

  isMobileDevice(breakpoint = this.MOBILE_WIDTH_SIZE): boolean {
    const hasCoarsePointer = window.matchMedia('(pointer: coarse)').matches;
    const noHoverSupport = !window.matchMedia('(hover: hover)').matches;

    return window.innerWidth < breakpoint || hasCoarsePointer || noHoverSupport;
  }

  onResize(debounce = 250): Observable<number> {
    this.resizeObservable$ = fromEvent(window, 'resize');

    return this.resizeObservable$.pipe(
      debounceTime(debounce),
      map(({ target }) => {
        const { innerWidth } = target as Window;

        return innerWidth;
      })
    );
  }
}
